import { useRouter } from 'next/router';
import useUserCompany from '@/src/utils/hooks/superstack/useUserCompany';
import useSSProfile from '@/src/utils/hooks/superstack/useSSProfile';
import { CompanyStacksCTA } from '@/src/component/superstack/companies/CompanyBanners';
import { PageCompanyStacks } from '@/src/component/superstack/companies/PageCompanyStacks';

export default function StacksCompanyWrapper() {
  const router = useRouter();
  const { id: companyId } = router.query;

  const { user: { data: user = {} } = {}, isLoading: isUserLoading } = useSSProfile();
  const { data: { data: company = {} } = {}, isLoading: isCompanyLoading } = useUserCompany(
    user.username,
  );
  const hasCompanyStack = company.stacks && company.stacks.length > 0;
  let banner = null;
  if (!isUserLoading && !isCompanyLoading) {
    banner =
      user?.username && !hasCompanyStack ? (
        <CompanyStacksCTA bannerMT={'-170px'} bannerHeight={'320px'} />
      ) : null;
  }
  return (
    <PageCompanyStacks
      companyId={companyId}
      editable={user?.is_staff || companyId * 1 === company?.id}
      banner={banner}
    />
  );
}
